<template>
  <div class="city-district-selector" v-if="show">

    <div class="searchbar_box flex_center">
      <button>
        <i class="icon-search"></i>
      </button>
      
      <select v-model="selectedCity" @change="onCityChange" class="city-select">
        <option v-if="parentPermission === 'granted' && canGeolocate" value="__gps__">📍 {{ (isLocating || parentIsLocating) ? '定位中....' : '我的位置' }}</option>
        <option value="">全部縣市</option>
        <option v-for="cityData in filteredCities" :key="cityData.city" :value="cityData.city">
          {{ cityData.city }}
        </option>
      </select>
      <select v-model="selectedDistrict" @change="onDistrictChange" class="district-select" :disabled="!selectedCity || selectedCity === '__gps__'">
        <option value="">全部行政區</option>
        <option v-for="district in availableDistricts" :key="district.name" :value="district.name">
          {{ district.name }}
        </option>
      </select>
      <button
        v-if="showGpsButton && canGeolocate"
        class="gps_btn"
        v-on:click="nearBySearch()"
        v-click-outside="hideAutocomplete"
      >
        <i v-show="!(isLocating || parentIsLocating)" class="icon-gps"></i>
        <div v-show="isLocating || parentIsLocating" class="loader"></div>
      </button>
    </div>
    <div class="autocomplete gps_click" v-show="gpsReason">
      <div class="group">
        <p class="label">
          {{ $t(gpsReason) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/services/apis";
import { citiesAndDistricts as mockCitiesAndDistricts } from "@/data/citiesAndDistricts";
import geolocationMixin from "@/mixins/geolocationMixin";

export default {
  name: "CityDistrictSelector",
  mixins: [geolocationMixin],
  props: {
    show: {
      type: Boolean,
      default: true
    },
    initialCity: {
      type: String,
      default: ''
    },
    initialDistrict: {
      type: String,
      default: ''
    },
    isGpsActive: {
      type: Boolean,
      default: false
    },
    parentPermission: {
      type: String,
      default: null
    },
    parentIsLocating: {
      type: Boolean,
      default: false
    },
    shopAddresses: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showGpsButton: true,
      selectedCity: "",
      selectedDistrict: "",
      gpsReason: "",
      citiesAndDistricts: [],
      canGeolocate: false,
      previousCity: "", // 保存定位前的縣市選擇
      previousDistrict: "" // 保存定位前的行政區選擇
    };
  },
  computed: {
    availableDistricts() {
      if (!this.selectedCity || this.selectedCity === "__gps__") {
        return [];
      }
      const cityData = this.citiesAndDistricts.find(c => c && c.city === this.selectedCity);
      if (!cityData) return [];
      if (!this.shopAddresses.length) return cityData.districts;
      return cityData.districts.filter(d =>
        this.shopAddresses.some(addr => addr.includes(this.selectedCity) && addr.includes(d.name))
      );
    },
    filteredCities() {
      const cities = this.citiesAndDistricts.filter(c => c && c.city);
      if (!this.shopAddresses.length) return cities;
      return cities.filter(c =>
        this.shopAddresses.some(addr => addr.includes(c.city))
      );
    }
  },
  methods: {
    onCityChange(event) {
      const val = event.target.value;
      console.log('CityDistrictSelector [EVENT] onCityChange raw value:', val);
      
      this.selectedCity = val || "";
      this.selectedDistrict = "";
      
      if (this.selectedCity === "__gps__") {
        console.log('CityDistrictSelector: Triggering GPS search');
        this.nearBySearch();
      } else {
        console.log('CityDistrictSelector: Triggering emitChange for city:', this.selectedCity);
        this.emitChange();
      }
    },
    onDistrictChange() {
      this.emitChange();
    },
    emitChange() {
      const result = {
        city: this.selectedCity || "",
        district: this.selectedDistrict || "",
        lat: null,
        lng: null
      };

      if (this.selectedCity) {
        const cityData = this.citiesAndDistricts.find(c => c.city === this.selectedCity);
        if (cityData) {
          if (this.selectedDistrict) {
            // 若選了行政區，使用行政區經緯度
            const districtData = cityData.districts.find(d => d.name === this.selectedDistrict);
            if (districtData) {
              result.lat = districtData.lat;
              result.lng = districtData.lng;
            }
          } else {
            // 若只選縣市，使用縣市中心經緯度
            if (cityData.lat && cityData.lng) {
              result.lat = cityData.lat;
              result.lng = cityData.lng;
            }
          }
        }
      }
      this.$emit('change', result);
    },
    hideAutocomplete() {
      $(".autocomplete.gps_click").slideUp();
    },
    nearBySearch() {
      // 保存當前的選擇（以便定位失敗時恢復）
      this.previousCity = this.selectedCity;
      this.previousDistrict = this.selectedDistrict;

      // 使用 mixin 的自動定位功能
      this.selectedCity = "__gps__";
      this.selectedDistrict = "";

      this.autoGeolocation(true, true);
    },

    /**
     * 套用定位篩選 (由 geolocationMixin 呼叫)
     * @param {Object} coords { lat, lng }
     */
    applyGeolocationFilter(coords) {
      if (coords && coords.lat && coords.lng) {
        // 重新定位時切換為「我的位置」
        this.selectedCity = "__gps__";
        this.selectedDistrict = "";

        // 直接將經緯度給父元件
        this.$emit('gps-search', {
          lat: coords.lat,
          lng: coords.lng
        });
      }
    },

    /**
     * 處理定位錯誤 (覆寫 mixin 的方法)
     * @param {PositionError} error
     * @param {Boolean} isManualRetry
     */
    handleGeolocationError(error, isManualRetry = false) {
      // 定位失敗時，恢復到原本的選擇
      this.selectedCity = this.previousCity || "";
      this.selectedDistrict = this.previousDistrict || "";

      // 呼叫 mixin 的原始方法來顯示錯誤訊息
      // 使用 Object.getPrototypeOf 來訪問 mixin 的方法
      const mixinMethod = geolocationMixin.methods.handleGeolocationError;
      if (mixinMethod) {
        mixinMethod.call(this, error, isManualRetry);
      }
    },

    //只計算縣市中心，直接用平均法，不用球面版
    getCenterLatLng(locations) {
      if (!locations || locations.length === 0) {
        return null
      }

      let latSum = 0
      let lngSum = 0

      locations.forEach(({ lat, lng }) => {
        latSum += lat
        lngSum += lng
      })

      return {
        lat: latSum / locations.length,
        lng: lngSum / locations.length
      }
    },
    async loadCitiesAndDistricts() {
      if (process.env.VUE_APP_USE_MOCK_DATA === 'true') {
        // 使用靜態資料 (mock data)
        this.citiesAndDistricts = mockCitiesAndDistricts;
      } else {
        try {
          const data = await apis.getTaiwanDistricts();
          this.citiesAndDistricts = data;
        } catch (error) {
          console.error('Failed to load cities and districts from API:', error);
          // Fallback to static data in case of API error
          this.citiesAndDistricts = mockCitiesAndDistricts;
        }
      }

      // 計算每個縣市的中心經緯度
      this.citiesAndDistricts.forEach(cityData => {
        if (cityData && cityData.districts && cityData.districts.length > 0) {
          const centerLatLng = this.getCenterLatLng(cityData.districts);
          if (centerLatLng) {
            cityData.lat = centerLatLng.lat;
            cityData.lng = centerLatLng.lng;
          }
        }
      });
    }
  },
  mounted() {
    this.loadCitiesAndDistricts();
    this.canGeolocate = !!navigator.geolocation;

    // 設定初始值
    if (this.isGpsActive) {
      this.selectedCity = "__gps__";
    } else {
      this.selectedCity = this.initialCity || "";
    }
    if (this.initialDistrict) {
      this.$nextTick(() => {
        this.selectedDistrict = this.initialDistrict || "";
      });
    }
  },
  watch: {
    initialCity(newVal) {
      console.log('CityDistrictSelector [WATCH] initialCity:', newVal, 'Current selectedCity:', this.selectedCity);
      const val = newVal || "";
      if (val !== this.selectedCity && this.selectedCity !== '__gps__') {
        console.log('CityDistrictSelector: Updating selectedCity from prop to:', val);
        this.selectedCity = val;
      }
    },
    initialDistrict(newVal) {
      console.log('CityDistrictSelector [WATCH] initialDistrict:', newVal, 'Current selectedDistrict:', this.selectedDistrict);
      const val = newVal || "";
      if (val !== this.selectedDistrict) {
        this.$nextTick(() => {
          this.selectedDistrict = val;
        });
      }
    },
    isGpsActive(newVal, oldVal) {
      console.log('CityDistrictSelector [WATCH] isGpsActive:', newVal, 'oldVal:', oldVal, 'Current selectedCity:', this.selectedCity);
      if (this.selectedCity) {

      } else if (newVal) {
        this.selectedCity = "__gps__";
        this.selectedDistrict = "";
      } else if (oldVal === true && this.selectedCity === "__gps__") {
        // 僅在「本來是 GPS 模式」且「目前還沒切換走」的情況下，GPS 被關閉才清空
        console.log('CityDistrictSelector: GPS deactivated by parent, clearing selection');
        this.selectedCity = "";
      }
    }
  }
};
</script>

<style scoped>
.city-district-selector {
  width: 100%;
}

.searchbar_box {
  display: flex;
  align-items: center;
  width: 100%;
}

.searchbar_box button {
  flex-shrink: 0;
  padding: 8px 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.searchbar_box button:first-child {
  display: none;
}

.city-select,
.district-select {
  flex: 1;
  min-width: 0;
  padding: 8px 10px;
  margin: 0;
  border: none;
  background: none;
  font-size: 14px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 5px center;
  background-size: 16px;
  padding-right: 25px;
  cursor: pointer;
}

.city-select:focus,
.district-select:focus {
  outline: none;
}

.city-select {
  border-right: 1px solid #E5E6E5;
  max-width: 45%;
}

.district-select {
  max-width: 45%;
}

.gps_btn {
  flex-shrink: 0;
  padding: 8px 12px;
  background: none;
  border: none;
  cursor: pointer;
}

.gps_btn .loader {
  width: 21px;
  height: 21px;
  border-width: 3px;
}

.autocomplete.gps_click {
  position: absolute;
  width: 95%;
  max-width: 768px;
  top: 45px;
  right: 0;
  left: 0;
  margin: 0 auto;
  padding: 15px 0 25px 0;
  text-align: left;
  background: #FFF;
  border: 1px solid #E5E6E5;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.autocomplete.gps_click .group {
  padding: 10px 30px;
}

.autocomplete.gps_click .label {
  color: #CB5A4B;
}
</style>
